"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.fieldsTokens = void 0;
const GlobalDesignToken_1 = require("../../types/GlobalDesignToken");
const fieldSizeNone = new GlobalDesignToken_1.GlobalDesignToken({
    name: 'field-size-none',
    fallback: '0px'
});
const fieldSizeXXS = new GlobalDesignToken_1.GlobalDesignToken({
    name: 'field-size-xxs',
    fallback: '80px'
});
const fieldSizeXS = new GlobalDesignToken_1.GlobalDesignToken({
    name: 'field-size-xs',
    fallback: '128px'
});
const fieldSizeS = new GlobalDesignToken_1.GlobalDesignToken({
    name: 'field-size-s',
    fallback: '176px'
});
const fieldSizeM = new GlobalDesignToken_1.GlobalDesignToken({
    name: 'field-size-m',
    fallback: '272px'
});
const fieldSizeL = new GlobalDesignToken_1.GlobalDesignToken({
    name: 'field-size-l',
    fallback: '368px'
});
const fieldSizeXL = new GlobalDesignToken_1.GlobalDesignToken({
    name: 'field-size-xl',
    fallback: '464px'
});
const fieldSizeXXL = new GlobalDesignToken_1.GlobalDesignToken({
    name: 'field-size-xxl',
    fallback: '560px'
});
const fieldSizeNormal = new GlobalDesignToken_1.GlobalDesignToken({
    name: 'field-size-normal',
    fallback: '169px'
});
const fieldSizeFull = new GlobalDesignToken_1.GlobalDesignToken({
    name: 'field-size-full',
    fallback: '100%'
});
exports.fieldsTokens = {
    fieldSizeNone,
    fieldSizeXXS,
    fieldSizeXS,
    fieldSizeS,
    fieldSizeM,
    fieldSizeL,
    fieldSizeXL,
    fieldSizeXXL,
    fieldSizeNormal,
    fieldSizeFull
};
//# sourceMappingURL=Fields.js.map